<template>
  <div class="table-container">
    <div v-if="users.length === 0" class="no-data-found">
      {{$t("no_data_found")}}
    </div>

    <table v-else class="table">
      <thead class="custom-thead">
      <tr>
        <th class="trhead custom-th">
          <span class="th-content">{{ $t("full_name") }}</span>
        </th>
        <th class="trhead custom-th">
          <span class="th-content">{{ $t("email_address") }}</span>
        </th>
        <th class="trhead custom-th">
          <span class="th-content">{{ $t("phone") }}</span>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for="user in users"
          :key="user.userId"
          class="tr-class hover-effect"
      >
        <router-link :to="'/users/detail/' + user.userId" class="router-link-row">
          <td class="td-style name-column">{{ user.name +" "+ user.surname }}</td>
        </router-link>

        <td class="td-style">{{ user.email }}</td>
        <td class="td-style">{{ user.phone }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    users: {
      type: Array,
      default: () => []
    }
  },

}
</script>

<style scoped>
.router-link-row {
  display: contents;
}

.name-column {
  cursor: pointer;
  transition: color 0.3s ease;
}

.name-column:hover {
  color: #4A68F8;
}

.router-link-active {
  text-decoration: none;
}
</style>
